import { Route, Routes } from "react-router";
import { ReportType } from "../../../../api/types/svTypes.ts";
import SmartViewAppPage from "./SmartViewAppPage";
import ApiEditRoot from "./components/builder/api-report/EditRoot";
import ApiReportsContainer from "./components/builder/api-report/ReportsContainer";
import ApiViewRoot from "./components/builder/api-report/ViewRoot";

const supportedReportTypes = [ReportType.Tabular];

const SmartViewApiReportPage = () => {
  return (
    <Routes>
      <Route element={<SmartViewAppPage supportedReportTypes={supportedReportTypes} />}>
        <Route element={<ApiReportsContainer />}>
          <Route path=":id/view" element={<ApiViewRoot />} />
          <Route path=":id/edit" element={<ApiEditRoot />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default SmartViewApiReportPage;
